import { render } from "./customer.vue?vue&type=template&id=41f4fc54&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=41f4fc54&scoped=true&lang=css"
import "./customer.vue?vue&type=style&index=1&id=41f4fc54&lang=css"
script.render = render
script.__scopeId = "data-v-41f4fc54"

export default script